import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { getUnique } from '../../../helpers/common'
import DetailTemplate from './detailTemplate'
import {
  addDefault,
  resetStoreDetailTemplate,
} from './detailTemplate/store/slice'
import './i18n'
import Templates from './templates'
import { resetStoreTemplates } from './templates/store/slice'

export const PreferenceSetting = ({ handleBack, template, detailTemplate }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { organizationId, showDetail } = new Proxy(
    new URLSearchParams(location.search),
    {
      get: (searchParam, prop) => searchParam.get(prop),
    },
  )

  useEffect(() => {
    dispatch(addDefault(detailTemplate))
  }, [JSON.stringify(detailTemplate.panelsSelected)])

  useEffect(() => {
    return () => {
      dispatch(resetStoreDetailTemplate())
      dispatch(resetStoreTemplates())
    }
  }, [])

  const setIsShowDetail = (val) => {
    const params = `?organizationId=${organizationId}&preferenceSetting=true${
      val ? '&showDetail=true' : ''
    }`
    navigate(detailTemplate.path + params)
  }

  const goToTemplateTable = () => setIsShowDetail(false)

  const backToDetailTemplate = () => setIsShowDetail(true)

  const openTemplate = (data) => {
    const panelsSelected = data[template.dataKey]
      ? JSON.parse(data[template.dataKey])
      : detailTemplate
          .getPanels(data.companyType)
          .map((panel) =>
            detailTemplate.formatDefaultPanel
              ? detailTemplate.formatDefaultPanel(panel)
              : { id: getUnique(), ...panel },
          )
    dispatch(
      addDefault({
        panelsSelected,
        templateName: data[template.nameKey],
        templateId: data[template.idKey],
        isFiinGateTemplate: data.isFiinGateTemplate,
        companyType: data.companyType,
      }),
    )
    backToDetailTemplate()
  }

  if (showDetail === 'true') {
    return (
      <DetailTemplate
        handleBack={handleBack}
        goToTemplateTable={goToTemplateTable}
        detailTemplate={detailTemplate}
      />
    )
  }

  return (
    <Templates
      backToDetailTemplate={backToDetailTemplate}
      template={template}
      openTemplate={openTemplate}
      setIsShowDetail={setIsShowDetail}
    />
  )
}

PreferenceSetting.propTypes = {
  handleBack: PropTypes.func,
  template: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ).isRequired,
    callApi: PropTypes.func.isRequired,
    callApiSearch: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    total: PropTypes.number,
    idKey: PropTypes.string.isRequired,
    nameKey: PropTypes.string.isRequired,
    dataKey: PropTypes.string.isRequired,
    deleteTemplate: PropTypes.func.isRequired,
    setDefaultTemplate: PropTypes.func.isRequired,
    updateTemplate: PropTypes.func.isRequired,
    callApiDefaultTemplate: PropTypes.func.isRequired,
    defaultTemplate: PropTypes.object,
    loadingSearch: PropTypes.bool,
    dataTemplateSearch: PropTypes.array,
    typeCompanyDisable: PropTypes.array,
  }).isRequired,
  detailTemplate: PropTypes.shape({
    getPanels: PropTypes.func.isRequired,
    panelsSelected: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    ),
    templateName: PropTypes.string,
    formatDefaultPanel: PropTypes.func,
    renderSettingPanel: PropTypes.func,
    saveTemplate: PropTypes.func,
    apply: PropTypes.func,
    ignorePath: PropTypes.string,
  }).isRequired,
}

PreferenceSetting.defaultProps = {
  handleBack: () => {},
}
